import { useCallback } from 'react';
import { VStack, Button } from '@cad-arc';
import { FrTabContentWrapper, TOTAL_USED_PAGE_HEIGHT } from './styled';
import { useEventDexActivityQuery } from '../../../event-panel/event-state/use-event-dex-activity-query';
import { useEventMetadataStore } from '../../../event-panel/event-panel-form/event-metadata';
import { useExportDexActivityMutation } from '../../../event-panel/tabs/dex/use-export-dex-activity-mutation';
import { LoadingIndicator } from '../../../common/components/loading-indicator';
import { useEnabledFeatures } from '../../../common/hooks/enabled-features/use-enabled-features';
import { DexActivityTabBodyContent } from '../../../event-panel/tabs/dex/dex-activity-tab-body-content';
import { useGetEventIdAndTabNameFromParams } from '../../hooks/use-get-event-id-and-tab-name-from-params';
import { FrDexNextTab } from './fr-dex-next-tab';

function FrDexTab() {
    const { eventId } = useGetEventIdAndTabNameFromParams();

    const { data, isInitialLoading } = useEventDexActivityQuery({
        eventId,
        queryOptions: { enabled: !!eventId },
    });

    const eventNumber = useEventMetadataStore().state.metadata?.agencyEventNumber;
    const exportDexActivityMutation = useExportDexActivityMutation();

    const handleExportClick = useCallback(() => {
        exportDexActivityMutation.mutate({ eventId, eventNumber });
    }, [eventId, eventNumber, exportDexActivityMutation]);

    const { dexActivityExportEnabled: userHasDexActivityExportAbility } = useEnabledFeatures();

    if (isInitialLoading) {
        return <LoadingIndicator />;
    }

    return (
        <FrTabContentWrapper>
            <VStack
                w="100%"
                h={`calc(100vh - ${TOTAL_USED_PAGE_HEIGHT}px)`}
                overflowY="auto"
                spacing={4}
                paddingTop="4px"
                paddingRight="8px"
                data-testid="fr-dex-tab-results"
            >
                {userHasDexActivityExportAbility && (
                    <Button
                        leadingVisual="Export"
                        variant="outline"
                        size="xl"
                        style={{ alignSelf: 'end' }}
                        onClick={handleExportClick}
                    >
                        Export
                    </Button>
                )}

                <DexActivityTabBodyContent
                    entries={data?.dexActivityTabEntries ?? []}
                    isInitialLoading={isInitialLoading}
                />
            </VStack>
        </FrTabContentWrapper>
    );
}

export default function FrDexTabWrapper() {
    const { dexNextEnabled } = useEnabledFeatures();

    if (dexNextEnabled) {
        return <FrDexNextTab />;
    }

    return <FrDexTab />;
}
